export const genericDocumentMask = "********************";
export const cnpjMask = "**.***.***/****-**";
export const cpfMask = "999.999.999-99";
export const passportMask = "********************";
